import React, { useEffect, useRef } from "react";
import { Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
// import { DeleteIncrementApi, UpdateIncrementApi } from "./STAction";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import MaterialTable from "material-table";
import moment from "moment";


const IncrementList = (props) => {
    const tableRef = useRef();
    // function updateTableQuery() {
    //     tableRef.current.onQueryChange()
    // };

    useEffect(() => {
        props.setHeading("Short Term Advance List")
    }, []);

    return (
        <>
            <Container fluid>
                <Form>
                    <MaterialTable
                        title="Short Term Advance List"
                        tableRef={tableRef}
                        columns={[
                            { title: "Employee Name", field: "employeeDetails.employeeName", editable: 'never' },
                            { title: "Date", field: "date", editable: 'never', render: rowData => moment(rowData.date).format('DD-MM-YYYY') },
                            { title: "Payment Type", field: "accType", editable: 'never' },
                            { title: "Payment Amount", field: "debitValue" },
                            { title: "Received Amount", field: "creditValue" },
                            { title: "Description", field: "description" },
                        ]}
                        data={(query) =>
                            new Promise((resolve, reject) => {
                                let url = `${baseURL}/shortTermAdv?`;
                                url += "size=" + query.pageSize;
                                url += "&page=" + query.page;
                                url += "&search=" + query.search;
                                fetch(url, {
                                    method: "GET",
                                    headers: headers,
                                }).then((response) => response.json()).then((result) => {
                                    resolve({
                                        data: result.data,
                                        page: result.page,
                                        totalCount: result.total_results,
                                    });
                                });
                            })
                        }
                        options={{
                            actionsColumnIndex: -1,
                            exportButton: true,
                            exportAllData: true,
                            paging: true,
                            pageSize: 50,
                            emptyRowsWhenPaging: false,
                            pageSizeOptions: [50, 100, 150, 200],
                            headerStyle: {
                                position: "sticky",
                                top: 0,
                                color: "#00BBBB",
                                fontWeight: "550",
                                onRowAdd: "none",
                            },
                        }}
                        // editable={{
                        //     isEditable: true,
                        //     isDeletable: true,
                        //     onRowUpdate: (newData, oldData) =>
                        //         new Promise((resolve) => {
                        //             setTimeout(() => {
                        //                 resolve();
                        //                 // props.UpdateIncrementApi(newData, oldData)
                        //             }, 600);
                        //         }),
                        //     onRowDelete: (oldData) =>
                        //         new Promise((resolve) => {
                        //             setTimeout(() => {
                        //                 resolve();
                        //                 // props.DeleteIncrementApi(oldData, updateTableQuery);
                        //             }, 600);
                        //         }),
                        // }}
                        actions={[
                            {
                                icon: 'refresh',
                                tooltip: 'Refresh Data',
                                isFreeAction: true,
                                onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                            },
                        ]}
                    />
                </Form>
            </Container>
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        // UpdateIncrementApi: (newData, oldData, updateTableQuery) => dispatch(UpdateIncrementApi(newData, oldData, updateTableQuery)),
        // DeleteIncrementApi: (data, updateTableQuery) => dispatch(DeleteIncrementApi(data, updateTableQuery)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    // isFetchingIncrement: state.IncrementReducer.isFetchingIncrement,
});

export default connect(mapStateToProps, mapDispatchToProps)(IncrementList);